import React from 'react';
//mui
import { Grid } from '@mui/material';
//widgets
import { AppNavigationBox } from './widgets';
//i18n
import i18n from 'i18';
import {
    EmptyWalletTransparentBulkIcon,
    Shop1BulkIcon,
    ScanBarcodeTranspBulkIcon
} from '../../icons-lib/bulkIcons';
import config from '../../config';

const wallets = config?.bannerImages?.wallets || '';
const partnerShops = config?.bannerImages?.partnerShops || '';
const coupons = config?.bannerImages?.coupons || '';

const NavigationBoxSection = ({ navigate }) => (
    <>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.wallets')}
                image={wallets}
                startIcon={<EmptyWalletTransparentBulkIcon />}
                handleClick={() => navigate('/app/wallets')}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.partnersShop')}
                image={partnerShops}
                startIcon={<Shop1BulkIcon />}
                handleClick={() => navigate('/app/merchants')}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.codesNCoupons')}
                image={coupons}
                startIcon={<ScanBarcodeTranspBulkIcon />}
                handleClick={() => navigate('/app/transaction-coupons')}
            />
        </Grid>
    </>
);

export default NavigationBoxSection;
